import React, { useState, useEffect, useMemo } from 'react';

import { dataGridPremiumColumns } from '../../utils/helper';
import { ColorCircleUi, DataGridIdentifiers, DatagridPremiumUi } from '../Interface';
import customDocStatusService from '../../service/customDocStatus.service';

const resolveDocumentTypeName = (row, documentTypes) => {
  if (row?.documentType?.name) return row.documentType.name;
  if (row?.documentTypeName) return row.documentTypeName;
  return documentTypes.find((item) => item.documentTypeId === row?.documentTypeId)?.name || '';
};

const CustomDocStatusReports = ({ refetch, values, viewField, operatorsDisabled, rowSelection, documentTypes }) => {
  const { refetchTable, setRefetchTable } = refetch;
  const { setSelectedValues } = values;
  const { rowSelectionModel, setRowSelectionModel } = rowSelection;

  const [reports, setReports] = useState({ rows: [], rowCount: 0 });

  const initialState = {
    filter: { filterModel: { items: [], logicOperator: 'and' } },
    sorting: {
      sortModel: [{ field: 'name', sort: 'asc' }],
    },
    pagination: {
      paginationModel: {
        pageSize: 25,
        page: 0,
      },
    },
    density: 'compact',
  };

  useEffect(() => {
    if (operatorsDisabled) {
      setRowSelectionModel([]);
    }
  }, [operatorsDisabled]);

  const getList = (gridState) => {
    customDocStatusService.getItems(gridState).then((data) => {
      setReports(data);
    });
  };

  const columns = useMemo(() => {
    return dataGridPremiumColumns([
      {
        field: 'documentTypeId',
        headerName: 'Bizonylattípus',
        type: 'string',
        renderCell: (data) => resolveDocumentTypeName(data.row, documentTypes),
      },
      {
        field: 'code',
        headerName: 'Kód',
        type: 'string',
      },
      {
        field: 'name',
        headerName: 'Megnevezés',
        type: 'string',
      },
      {
        field: 'visOrder',
        headerName: 'Sorrend',
        type: 'number',
        filterable: false,
      },
      {
        field: 'color',
        headerName: 'Szín',
        type: 'string',
        sortable: false,
        filterable: false,
        renderCell: (data) => (data.row.color ? <ColorCircleUi color={data.row.color} size={20} /> : ''),
      },
      {
        field: 'defaultValue',
        headerName: 'Alapértelmezett',
        type: 'boolean',
      },
      {
        field: 'active',
        headerName: 'Aktív',
        type: 'boolean',
      },
    ]);
  }, [documentTypes]);

  return (
    <DatagridPremiumUi
      datagridIdentifier={DataGridIdentifiers.CustomDocStatus}
      datagridInitialState={initialState}
      dataLoader={getList}
      rows={reports.rows}
      refetch={{ refetchTable, setRefetchTable }}
      rowCount={reports.rowCount}
      columns={[...columns]}
      onRowClick={(rowData) => {
        if (!viewField) return;
        setSelectedValues(rowData.row);
      }}
      paginationAndfilterMode="server"
      onRowSelectionModelChange={(newRowSelectionModel) => {
        setRowSelectionModel(newRowSelectionModel);
      }}
      rowSelectionModel={rowSelectionModel}
      disableRowSelectionOnClick={!viewField}
      getRowId={(row) => row.code}
    />
  );
};

export default CustomDocStatusReports;
